import Vue from "vue";
import Router from "@/router.js";


export const cartoonKidEventStore = new Vue({
  data() {
    return {
      jumpAction: null,
      next: null,
    };
  },
  methods: {
    resetJumpAction() {
      this.jumpAction = null;
    },
    setJumpAction(handle) {
      this.startWatchJumpAction();
      this.jumpAction = handle;
    },
    restNext() {
      this.next = null;
    },
    startWatchJumpAction() {
      this.watchJumpAction = this.$watch(
        () => Router.app.$route,
        (v) => {
          Router.app.$nextTick(() => {
            this.resetJumpAction();
            this.restNext();
            this.watchJumpAction();
          });
        }
      );
    },
  },
});
